















































import Vue from 'vue'
import {
  FolderServiceProxy,
  NewFolderDto,
  FileServiceProxy,
  CreateFileDto
} from '@/service-proxies/app-v2/dnc.service-proxies'
const folderservice = new FolderServiceProxy()
const fileservice = new FileServiceProxy()

import {
  OssFile,
  ServiceProxy as ResourceServiceProxy
} from '@/service-proxies/app-v2/resource.service-proxies'
const resourceService = new ResourceServiceProxy()

export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    addway: {
      type: String,
      default: 'file'
    },
    parentid: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      form: this.$form.createForm(this)
    }
  },
  computed: {
    addtitle() {
      return this.addway === 'file'
        ? this.$t('page_my_document_newfile')
        : this.$t('page_my_document_newfolder')
    },
    addlabel() {
      return this.addway === 'file'
    }
  },
  methods: {
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (this.addway === 'file') {
            let newFile = new File([new Blob([values.content])], values.name)
            let bladeFile = await resourceService.putFileUsingPOST({
              fileName: values.name + '.txt',
              data: newFile
            })
            let ossFile = (await resourceService.statFileUsingGET(bladeFile.data.name)).data

            const value = new CreateFileDto({
              ossFile: ossFile as OssFile,
              originalName: values.name,
              targetId: this.parentid
            })

            fileservice.createFile(value).then(() => {
              this.form.resetFields()
              this.$emit('close', true)
            })
          } else {
            const data = {
              name: values.name,
              parent: this.parentid
            } as NewFolderDto
            folderservice.create(data).then(() => {
              this.form.resetFields()
              this.$emit('close', true)
            })
          }
        }
      })
    },
    handleCancel() {
      this.form.resetFields()
      this.$emit('close', false)
    },
    validateToFileName(rule, value, callback) {
      const pattern = new RegExp('[\/:*?"<>|]')
      if (pattern.test(value)) {
        callback(this.$t('page_my_ducument_cannot_contain') + '!')
      } else {
        callback()
      }
    }
  }
})
